<template>
  <div :class="$style.container">
    <div :class="$style.slideList">
      <img
        :src="item.url"
        alt=""
        v-for="(item, index) in loopArr"
        :key="item.id"
        :style="{
          zIndex: item.zIndex,
          transform: item.transform,
          left: item.left,
        }"
        @touchstart.stop="handleTouchStart"
        @touchmove.stop="handleTouchMove"
        @touchend.stop="handleTouchEnd(item, index)"
      />
    </div>
    <div :class="$style.dotList">
      <span v-for="(item, index) in loopArr" :key="index" :class="nowId === item.id ? $style.active : ''"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgArr: {
      default: () => [],
    },
    autoplay: {
      default: true,
    },
    aniTime: {
      default: 500,
    },
    intervalTime: {
      default: 1500,
    },
  },
  data() {
    return {
      nowId: null, // 当前轮播哪个
      nowIndex: 0,
      loopArr: [],
      timer: null,
      clientX: 0,
      clientY: 0,
      isClick: true,
      endTouches: null,
      lastLeft: 0,
      lastDom: null,
    };
  },
  mounted() {
    this._initSilde();
  },
  methods: {
    _initSilde(initIndex = 0) {
      if (!this.imgArr.length) return;
      this.loopArr = this.imgArr;
      this.nowId = this.loopArr[initIndex].id;
      this.resetLoopOffset(true);
      if (this.autoplay && this.imgArr.length > 1) {
        this.startLoop();
      }
    },
    resetLoopOffset(initFlag) {
      this.nowIndex = this.loopArr.findIndex((item) => item.id === this.nowId);
      if (this.nowIndex < this.loopArr.length - 1 && !initFlag) {
        this.nowId = this.loopArr[this.nowIndex + 1].id;
        this.nowIndex = this.nowIndex + 1;
      } else {
        this.nowId = this.loopArr[0].id;
        this.nowIndex = 0;
      }
      this.resetLoopList();
    },
    resetLoopList() {
      this.loopArr = this.loopArr.map((item, index) => {
        // if ((this.nowIndex === 0 && index === this.loopArr.length - 1) || index === this.nowIndex - 1) {
        //   return {
        //     ...item,
        //     transform: `scale(${0.92})`,
        //     zIndex: 100,
        //     left: `-100%`,
        //   };
        // } else 
        if (index === this.nowIndex) {
          return {
            ...item,
            transform: `scale(${0.92})`,
            zIndex: 100,
            left: `0px`,
          };
        } else if (index < this.nowIndex) {
          return {
            ...item,
            transform: `scale(${0.92 - (index + (this.loopArr.length - this.nowIndex)) / 50})`,
            zIndex: 100 - (index + (this.loopArr.length - this.nowIndex)),
            left: `${(index + (this.loopArr.length - this.nowIndex)) * 12}px`,
          };
        } else {
          return {
            ...item,
            transform: `scale(${0.92 - (index - this.nowIndex) / 50})`,
            zIndex: 100 - (index - this.nowIndex),
            left: `${(index - this.nowIndex) * 12}px`,
          };
        }
      });
    },
    startLoop() {
      this.timer = setInterval(this.resetLoopOffset, this.intervalTime + this.aniTime);
    },
    clearLoop() {
      this.timer && clearInterval(this.timer);
    },
    handleTouchStart(e) {
      this.clearLoop();
      this.isClick = true;
      const touches = e.touches[0];
      this.clientX = touches.clientX;
      this.clientY = touches.clientY;
      this.lastDom = e.target;
      this.lastLeft = e.target.style.left;
    },
    handleTouchMove(e) {
      const touches = e.touches[0];
      if (touches.clientX === this.clientX && touches.clientY === this.clientY) {
        this.isClick = true;
      } else {
        this.isClick = false;
        if (this.imgArr.length <= 1) return;
        e.target.style.left = `${touches.clientX - this.clientX}px`;
        this.endTouches = touches;
      }
    },
    handleClick(item, index) {
      this.$emit('click', item, index);
    },
    handleTouchEnd(item, index) {
      if (this.isClick) {
        this.handleClick(item, index);
      } else {
        if (this.imgArr.length <= 1) return;
        if (Math.abs(this.endTouches.clientX - this.clientX) > 100) {
          if (this.endTouches.clientX < this.clientX) {
            this.nowId = this.nowIndex === this.loopArr.length - 1 ? this.loopArr[0].id : this.loopArr[this.nowIndex + 1].id;
          } else if (this.endTouches.clientX > this.clientX) {
            this.nowId = this.nowIndex === 0 ? this.loopArr[this.loopArr.length - 1].id : this.loopArr[this.nowIndex - 1].id;
          }
        } else {
          this.lastDom.style.left = this.lastLeft;
        }
        this.nowIndex = this.loopArr.findIndex((item) => item.id === this.nowId);
        this.resetLoopList();
      }
      if (this.imgArr.length > 1) this.startLoop();
    },
  },
  computed: {},
  beforeDestroy() {
    this.clearLoop();
  },
};
</script>
<style module lang="scss">
.container {
  width: 94%;
  height: 100px;
  overflow: hidden;
  margin: auto;
  position: relative;
  .slideList {
    position: relative;
    left: -10px;
    width: 100%;
    height: 100%;
    img {
      border-radius: 5px;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transition: all 300ms ease-out;
    }
  }
  .dotList {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 90px;
    height: 15px;
    z-index: 101;
    display: flex;
    > span {
      width: 5px;
      height: 5px;
      margin: 0 2px;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.6);
      &.active {
        width: 15px;
        background-color: #ffffff;
        transition: all 250ms linear;
      }
    }
  }
}
</style>
